import { useQuery } from '@tanstack/react-query';
import peopleService from '@/lib/api/people';

export function usePeopleMetrics(
  organizationId: string | undefined,
  filters?: { date_from?: string; date_to?: string },
) {
  return useQuery({
    queryKey: ['people-metrics', organizationId, filters?.date_from, filters?.date_to],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');

      const response = await peopleService.getPeopleMetrics(organizationId, filters);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch people metrics');
      }

      return response.data;
    },
    enabled: !!organizationId,
    staleTime: 30 * 1000,
  });
}
